import FalconCloseButton from 'components/common/FalconCloseButton';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { Button, Col, Form, Modal, Row, Spinner } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-loading-skeleton/dist/skeleton.css';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

const ModalSeleccionarTipoRenovacion = ({
    showModalTipoRenovacion,
    setShowModalTipoRenovacion,
    productoSeleccionado,
    onAgregarProducto
}) => {

    const { token, setToken } = useToken();
    const { register, reset, handleSubmit, formState: { errors } } = useForm();
    const [procesandoModal, setProcesandoModal] = useState(false);
    const [tiposRenovacion, setTiposRenovacion] = useState([]);
    const [cargandoTipos, setCargandoTipos] = useState(false);
    const { showErrorToast, showSuccessToast } = useToast();

    /**
     * Obtener los tipos de renovación del producto
     */
    const obtenerTiposRenovacion = async (idProducto) => {
        setCargandoTipos(true);
        try {
            const response = await fetch(`/api/orden/ObtenerProductoRenovaciones/?idProducto=${idProducto}`, {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                console.log("Tipos de renovación:", data);

                if (data.iResponseType == 1) {
                    const tiposRenovacionData = JSON.parse(data.detalles);
                    setTiposRenovacion(tiposRenovacionData);
                } else {
                    
                    showErrorToast(data.vMessage || 'Error al obtener tipos de renovación');
                }
            } else {
                
                showErrorToast(`Error ${response.status}: ${response.statusText}`);

                if (response.status == 401) {
                    setToken(null);
                    location.href = "";
                }
            }
        } catch (error) {
            
            showErrorToast(`Error de conexión: ${error.message}`);
            console.error('Error al obtener tipos de renovación:', error);
        } finally {
            setCargandoTipos(false);
        }
    };

    /**
     * Submit del formulario
     */
    const onSubmitSeleccion = data => {
        setProcesandoModal(true);

        try {
            // Buscar el tipo de renovación seleccionado
            const tipoRenovacionSeleccionado = tiposRenovacion.find(
                tipo => tipo.idProductoRenovaciones == data.idProductoRenovaciones
            );

            if (!tipoRenovacionSeleccionado) {
                throw new Error('No se encontró el tipo de renovación seleccionado');
            }

            if (!productoSeleccionado) {
                throw new Error('No hay producto seleccionado');
            }

            // Llamar a la función del componente padre para agregar el producto
            onAgregarProducto(productoSeleccionado, tipoRenovacionSeleccionado);

            showSuccessToast(`Producto agregado: ${productoSeleccionado.vNombreProducto} - Renovación ${tipoRenovacionSeleccionado.vTipoRenovacion}`);

            handleCloseModal();

        } catch (error) {
            showErrorToast(error.message || 'Error al procesar la selección');
            console.error('Error en onSubmitSeleccion:', error);
        } finally {
            setProcesandoModal(false);
        }
    };

    /**
     * Cerrar modal y limpiar estados
     */
    const handleCloseModal = () => {
        setShowModalTipoRenovacion(false);
        setTiposRenovacion([]);
        setProcesandoModal(false);
        reset();
    };

    /**
     * useEffect para cargar tipos de renovación cuando se abre el modal
     */
    useEffect(() => {
        if (showModalTipoRenovacion && productoSeleccionado?.idProducto) {
            obtenerTiposRenovacion(productoSeleccionado.idProducto);
        }
    }, [showModalTipoRenovacion, productoSeleccionado]);

    if (!showModalTipoRenovacion) return null;

    return (
        <Modal
            show={showModalTipoRenovacion}
            onHide={handleCloseModal}
            size="md"
            backdrop="static"
            aria-labelledby="modal-tipo-renovacion"
            centered
        >
            <Form noValidate onSubmit={handleSubmit(onSubmitSeleccion)}>
                <Modal.Header>
                    <Modal.Title id="modal-tipo-renovacion">
                        Seleccionar Tipo de Renovación
                    </Modal.Title>
                    <FalconCloseButton
                        className="btn btn-circle btn-sm transition-base p-0"
                        onClick={handleCloseModal}
                    />
                </Modal.Header>
                <Modal.Body>
                    {productoSeleccionado && (
                        <Row>
                            <Col>
                                <div className="mb-3">
                                    <strong>Producto:</strong> {productoSeleccionado.vNombreProducto}
                                    <br />
                                    <small className="text-muted">
                                        Código: {productoSeleccionado.vCodigoBarras}
                                    </small>
                                </div>
                                <hr />
                            </Col>
                        </Row>
                    )}

                    {cargandoTipos ? (
                        <Row>
                            <Col className="text-center py-4">
                                <Spinner animation="border" role="status" variant="primary">
                                    <span className="visually-hidden">Cargando...</span>
                                </Spinner>
                                <p className="mt-2 text-muted">Cargando tipos de renovación...</p>
                            </Col>
                        </Row>
                    ) : tiposRenovacion.length > 0 ? (
                        <Row>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Selecciona el tipo de renovación:</Form.Label>
                                    <Form.Select
                                        aria-label="Seleccionar tipo de renovación"
                                        isInvalid={!!errors.idProductoRenovaciones}
                                        {...register("idProductoRenovaciones", {
                                            required: "Debes seleccionar un tipo de renovación"
                                        })}
                                    >
                                        <option value="">Selecciona una opción...</option>
                                        {tiposRenovacion.map((tipo) => (
                                            <option
                                                key={tipo.idProductoRenovaciones}
                                                value={tipo.idProductoRenovaciones}
                                            >
                                                {tipo.vTipoRenovacion.charAt(0).toUpperCase() + tipo.vTipoRenovacion.slice(1)} -
                                                ${parseFloat(tipo.dTotal).toFixed(2)} {tipo.vMoneda || 'MXN'}
                                            </option>
                                        ))}
                                    </Form.Select>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.idProductoRenovaciones?.message}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Col>
                        </Row>
                    ) : (
                        <Row>
                            <Col>
                                <div className="alert alert-warning" role="alert">
                                    <i className="fas fa-exclamation-triangle me-2"></i>
                                    No se encontraron tipos de renovación disponibles para este producto.
                                </div>
                            </Col>
                        </Row>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        onClick={handleCloseModal}
                        variant="secondary"
                        disabled={procesandoModal}
                    >
                        Cancelar
                    </Button>
                    {procesandoModal ? (
                        <Button variant="primary" disabled>
                            <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                className="me-2"
                            />
                            Procesando...
                        </Button>
                    ) : (
                        <Button
                            type="submit"
                            variant="success"
                            disabled={cargandoTipos || tiposRenovacion.length === 0}
                        >
                            <i className="fas fa-cart-plus me-2"></i>
                            Agregar al Carrito
                        </Button>
                    )}
                </Modal.Footer>
            </Form>
        </Modal>
    );
};

ModalSeleccionarTipoRenovacion.propTypes = {
    showModalTipoRenovacion: PropTypes.bool.isRequired,
    setShowModalTipoRenovacion: PropTypes.func.isRequired,
    productoSeleccionado: PropTypes.object,
    onAgregarProducto: PropTypes.func.isRequired
};

export default ModalSeleccionarTipoRenovacion;